import React from 'react';
import { Card, Button, Row, Col, Tag, Spin, Alert } from 'antd';
import { ClockCircleOutlined, FileProtectOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './PracticeTestsComponent.scss';

const PracticeTestsComponent = ({ practiceTests, loading, error, onTakeTest }) => {
  const { t } = useTranslation('practice_tests');
  const history = useHistory();

  const handleViewAttempts = (testId, testTitle) => {
    // Encode the test title to handle special characters
    const encodedTitle = encodeURIComponent(testTitle);
    history.push(`/practices-attempts/${encodedTitle}/${testId}`);
  };
  const getDifficulty = experience => {
    if (experience < 2) return { label: t('practice_tests.difficulty.easy'), color: '#d9d9d9' };
    if (experience < 5) return { label: t('practice_tests.difficulty.medium'), color: '#d9d9d9' };
    return { label: t('practice_tests.difficulty.hard'), color: '#d9d9d9' };
  };

  if (error) {
    return (
      <div className={styles['error-container']}>
        <Alert
          message="Error"
          description={t('practice_tests.error.load_tests')}
          type="error"
          showIcon
        />
      </div>
    );
  }

  return (
    <div className={styles['practice-tests-container']}>
      <div className={styles['header']}>
        <div className={styles['header-content']}>
          <FileProtectOutlined className={styles['header-icon']} />
          <div className={styles['header-text']}>
            <h1 className={styles['title']}>{t('practice_tests.title')}</h1>
            <p className={styles['subtitle']}>{t('practice_tests.subtitle')}</p>
          </div>
        </div>
      </div>

      <Row
        gutter={[24, 24]}
        className={styles['tests-grid']}
      >
        {practiceTests.map(test => {
          const difficulty = getDifficulty(test.experience);
          return (
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={12}
              xl={8}
              key={test.id}
              className={styles['test-card-col']}
            >
              <Card
                className={styles['test-card']}
                hoverable
              >
                <div className={styles['test-header']}>
                  <div className={styles['test-header-top']}>
                    <h3 className={styles['test-title']}>{test.title}</h3>
                  </div>
                  <div className={styles['difficulty-tag']}>
                    <Tag
                      className={styles['tag']}
                      color={difficulty.color}
                    >
                      {difficulty.label}
                    </Tag>
                  </div>
                  <div className={styles['time-info']}>
                    <ClockCircleOutlined className={styles['time-icon']} />
                    <span>
                      {test.total_time > 0
                        ? test.total_time
                        : test.sections?.reduce(
                            (sum, section) => sum + (section.total_time || 0),
                            0,
                          ) || 0}{' '}
                      {t('practice_tests.test_result.mins')}
                    </span>
                  </div>
                </div>

                <div className={styles['test-footer']}>
                  <span
                    className={styles['attempts']}
                    onClick={() => handleViewAttempts(test.id, test.title)}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('practice_tests.attempts', { count: test.attempts || 0 })}
                  </span>
                  <Button
                    type="primary"
                    onClick={() => onTakeTest(test.id)}
                    className={styles['take-test-button']}
                  >
                    {t('practice_tests.take_test')}
                  </Button>
                </div>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default PracticeTestsComponent;
